import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Integration, IntegrationType } from '@pdqdev/pdq-shared/dist/entities';
import { IntegrationsService } from '@services/integrations/integrations.service';

@Component({
  selector: 'okendo-settings',
  templateUrl: './okendo-settings.component.html',
  styleUrls: ['./okendo-settings.component.scss'],
  standalone: false,
})
export class OkendoSettingsComponent implements OnInit {
  @Input() integrationType?: IntegrationType;
  @Input() integration?: Integration;

  okendoUserId: string = '';

  private destroyRef = inject(DestroyRef);

  constructor(private integrationService: IntegrationsService) {}

  ngOnInit(): void {
    this.integrationService.integrations$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((integrations) => {
      if (!this.integrationType) return;
      this.integration = integrations[this.integrationType.name]?.instance;
      this.okendoUserId = this.integration?.metadata?.okendoUserId ?? '';
    });
  }
}
